import { INTENT_HREF } from './cta';
import { icon } from './icons';
import { eyebrow } from './primitives';

/* ---- Integrations (Platform page) ----
   List from ReTax360's original brief. Keep it to systems ReTax360 connects to today. */
const INTEGRATIONS = [
  ['Google Workspace', 'Email, identity and collaboration'],
  ['Google Calendar', 'Scheduling, deadlines and hearings'],
  ['Google Drive', 'Document storage'],
  ['Microsoft OneDrive', 'Document storage'],
  ['DocuSign', 'Engagement letters and authorizations'],
  ['Jotform', 'Client intake forms'],
  ['SendGrid', 'Transactional email'],
  ['Twilio', 'Text messaging'],
  ['Stripe', 'Payments and invoicing'],
  ['REST API &amp; webhooks', 'Your systems of record'],
];
export function integrationsSection(): string {
  return `
  <section class="s" id="integrations" aria-labelledby="int-h">
    <div class="wrap">
      <div class="head-row">
        <div class="head rv">${eyebrow('Integrations')}<h2 id="int-h">Works with the systems you already use.</h2><p>ReTax360 connects to the tools property tax teams already rely on, and to your existing systems of record through APIs and webhooks.</p></div>
        <div class="rv"><a class="tlink" href="${INTENT_HREF['enterprise-contact']}" data-cta="ask_about_integration">Ask about an integration ${icon('arrow')}</a></div>
      </div>
      <ul class="integ-grid rv" aria-label="Integrations">${INTEGRATIONS.map(([n, d]) => `<li><b>${n}</b><small>${d}</small></li>`).join('')}</ul>
      <p class="fine rv" style="margin-top:16px">Product names are trademarks of their respective owners. Integration availability depends on your deployment.</p>
    </div>
  </section>`;
}
